module.exports = __webpack_public_path__ + "static/screenshot2-cf1e2d9d96085511e361ca6caac17ba4.png";